import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { BiPrinter } from 'react-icons/bi';
import { FaFacebook, FaPinterest, FaTwitter } from 'react-icons/fa';
import { ShareBarContainer, ShareBarText, ShareBarButton } from './ShareBar.style';
import { IShareBarProps } from './ShareBar.i';
import { SocialSharingContext } from '../SocialSharingContext';
import { LazyLoadContext } from '@riac/core';

export const ShareBar = ({ title, text, image }: IShareBarProps) => {
  const location = useLocation();
  const currentUrl = `https://www.rockislandauction.com${location.pathname}`;
  const { setForceLoad } = useContext(LazyLoadContext);
  const { printButtonUsed, setPrintButtonUsed } = useContext(SocialSharingContext);
  const [doPrint, setDoPrint] = useState<boolean>(false);

  const handleShare = (site: string) => {
    switch (site) {
      case 'facebook':
        return window.open(
          `https://www.facebook.com/sharer/sharer.php?app_id=1694870180767912&kid_directed_site=0&sdk=joey&u=${encodeURIComponent(currentUrl)}&display=popup&ref=plugin&src=share_button`,
          'Facebook Share',
          'width=600,height=420'
        );
      case 'twitter':
        return window.open(
          `https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw&text=${title}&tw_p=tweetbutton&url=${encodeURI(currentUrl)}`,
          'Twitter Share',
          'width=600,height=420'
        );
      case 'pinterest':
        return window.PinUtils.pinOne({
          'url': currentUrl,
          'media': image,
          'description': `${title}`,
        });
      default:
        // This sets off a cascade of state flags being set
        // This cascade is important to make sure that these states
        // are carried out (rendered) before setting the next state flag
        setPrintButtonUsed(true);
    }
  };

  useEffect(() => {
    const handleAfterPrint = () => {
      setDoPrint(false);
      setPrintButtonUsed(false);
    };

    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  useEffect(() => {
    if(printButtonUsed === true)
    {
      setForceLoad(true);
      setDoPrint(true);
    }
  }, [printButtonUsed]);

  useEffect(() => {
    if(doPrint === true )
    {
      // check and wait for all img tags to be loaded
      const checkInterval = setInterval(() => {
        const images = document.querySelectorAll('img');
        let done = true;

        for(let i = 0; i < images.length; i++) {
          if(!images[i].complete)
          {
            done = false;
          }
        }

        if(done)
        {
          clearInterval(checkInterval);
          // window.focus() is imporant for making sure the afterprint event fires
          window.focus();
          window.print();
        }
      }, 100);
    }
  }, [doPrint]);

  return (
    <ShareBarContainer>
      <ShareBarText>{text || 'Share this post:'}</ShareBarText>
      <ShareBarButton onPress={() => handleShare('print')} aria-label='Print'><BiPrinter/></ShareBarButton>
      <ShareBarButton onPress={() => handleShare('twitter')} aria-label='Twitter'><FaTwitter/></ShareBarButton>
      <ShareBarButton onPress={() => handleShare('facebook')} aria-label='Facebook'><FaFacebook/></ShareBarButton>
      <ShareBarButton onPress={() => handleShare('pinterest')} aria-label='Pinterest'><FaPinterest/></ShareBarButton>
    </ShareBarContainer>
  );
};
